import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MessageFormLink } from '@weavix/models/src/channel/channel-message';
import { IconComponent } from 'components/icon/icon.component';
import { environment } from 'environments/environment';
import { workFormsContext } from 'models-mobx/work-forms-store/work-forms-store';

@Component({
    selector: 'app-channel-message-form',
    templateUrl: './channel-message-form.component.html',
    styleUrls: ['./channel-message-form.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        IconComponent,
    ],
})
export class ChannelMessageFormComponent implements OnChanges {
    @Input() formLink: MessageFormLink;
    @Input() isSender: boolean;
    @Input() deletable: boolean;

    @Output() removeFormLink = new EventEmitter<MessageFormLink>();

    teamsApp = environment.teamsApp;
    name: string;
    closeIcon = 'fal fa-times';

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['formLink']?.currentValue) {
            const form = workFormsContext.getDefault().get(this.formLink.formId);
            this.name = form?.name ?? undefined;
        }
    }
}